import * as React from 'react';

function SvgProgressSignContract(props) {
  return (
    <svg width={18} height={18} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#progress-sign-contract_svg__clip0_227_6944)">
        <path d="M15.43.964h-2.17V.161A.161.161 0 0013.099 0h-1.125a.161.161 0 00-.16.16v.804H8.76V.161A.161.161 0 008.599 0H7.474a.161.161 0 00-.16.16v.804h-2.17a.642.642 0 00-.643.643v2.41H2.572a.642.642 0 00-.643.644v12.696c0 .356.287.643.643.643h10.286a.642.642 0 00.643-.643V15.43h1.928a.642.642 0 00.643-.643V1.607a.642.642 0 00-.643-.643zm-3.376 15.59H3.376V5.464h4.38V8.96c0 .444.359.803.803.803h3.495v6.79zm0-8.076H9.041V5.464h.004l3.01 3.01v.004zm2.572 5.504H13.5V7.875L9.643 4.018H5.947V2.41h1.366v.643c0 .088.072.16.16.16H8.6c.088 0 .16-.072.16-.16V2.41h3.054v.643c0 .088.072.16.16.16H13.1c.088 0 .16-.072.16-.16V2.41h1.367v11.571z" />
      </g>
      <defs>
        <clipPath id="progress-sign-contract_svg__clip0_227_6944">
          <path d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgProgressSignContract;
